import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ERROR_MESSAGE } from 'src/app/_helpers/utils';
import { FormBase } from 'src/app/_models/form-base';

@Component({
  selector: 'app-underlined-textarea-field',
  templateUrl: './underlined-textarea-field.component.html',
  styleUrls: ['./underlined-textarea-field.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnderlinedTextareaFieldComponent {
  /** Field form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Number of rows (optional, default: 5) */
  rows = input<number>(5);

  /** Number of columns (optional, default: 30) */
  columns = input<number>(30);

  /** Minimum character length (required) */
  minLength = input<number>();

  /** Maximum character length (required) */
  maxLength = input<number>();

  /** Whether to show character counter (optional, default: false) */
  showCharacterCounter = input<boolean>(false);

  /** The visual style of the label (optional, default: 'standard') */
  labelSize = input<'standard' | 'small'>('standard');

  public get hasErrors(): boolean {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return false;
    const ctrl = form.controls[f.key];
    return !!(ctrl && ctrl.errors && ctrl.touched);
  }

  public get errorsList(): string[] {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return [];
    const ctrl = form.controls[f.key];
    if (!ctrl || !ctrl.errors) return [];
    return Object.keys(ctrl.errors).map((err) => {
      const errorFn = ERROR_MESSAGE[err as keyof typeof ERROR_MESSAGE];
      return errorFn ? errorFn(ctrl.getError(err) as never) : 'Unknown error';
    });
  }

  public get currentLength(): number {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return 0;
    return form.controls[f.key]?.value?.length || 0;
  }

  public get isAtMaxLength(): boolean {
    const max = this.maxLength();
    return max != null && this.currentLength >= max;
  }

  public get isNearMaxLength(): boolean {
    const max = this.maxLength();
    return max != null && this.currentLength >= max * 0.9;
  }
}
